import React from 'react';
import ScrollMenu from 'react-horizontal-scrolling-menu';
import './RssMediaFeed.scss';

const Arrow = ({ text, className, color }) => {
  return (
    <div
      className={className}
      style={{padding: 10, cursor: 'pointer', color}}
    >{text}</div>
  );
};

class RssMediaFeed extends React.Component {
  constructor(props) {
    super(...arguments);
    this.state = this.getStateFromProps(props);
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    this.setState(this.getStateFromProps(newProps));
  }

  getStateFromProps(props) {
    let feed = FW.store.get('feed-' + props.section.get('id'));
    const title = props.section.prop('custom_title') || feed.title;
    return {
      items: feed.items,
      title: title
    };
  }

  render() {
    const ArrowLeft = Arrow({ text: '', className: 'arrow-prev fa fa-arrow-left', color: this.props.section.ls('arrow-color') || '#000' });
    const ArrowRight = Arrow({ text: '', className: 'arrow-next fa fa-arrow-right', color: this.props.section.ls('arrow-color') || '#000' });



    let items = this.state.items.map((item, i) => {
      const url = item.href.indexOf('iframe.php') >= 0 ? '/feed-embed/' + this.props.section.get('id') + '?url=' + encodeURIComponent(item.href) : item.href;

      return <div key={`feed-item-${i}`} style={{paddingLeft: 5, paddingRight: 5}}>
        <div className="well feed-item">
          <a href={url}>
            <img src={item.image} />
          </a>
          <h5>
            <a href={url} style={{textOverflow: 'ellipsis', width: '100%', overflow: 'hidden', whiteSpace: 'nowrap'}}>{item.title}</a>
          </h5>
          <span style={{marginBottom: 5}}>{item.date}</span>
          <div style={{height: '3.6em'}}>
            <div className="block-with-text" dangerouslySetInnerHTML={{__html: item.description}}></div>
          </div>
          <br style={{width: '100%', clear: 'both'}} />
        </div>
      </div>;
    });
    return <div className="fw-rss-media-feed-section">
      <ScrollMenu
        data={items}
        arrowLeft={ArrowLeft}
        arrowRight={ArrowRight}
        alignCenter={false}
        wheel={false}
        hideSingleArrow={true}
        hideArrows={true}
      />
    </div>;
  }
}

export default RssMediaFeed;
